<main role="main" class="page-Chantiers-infrastructures not-home-page">
    <div class="container">
      <div class="row">
        <div class="col-md-12 index-up">
          <div>
            <app-breadcrumb></app-breadcrumb>
          </div>
          <h2>{{ bloctitle.title }}</h2>
          <p class="text-primary size18 font-weight-semibold" >
            {{ bloctitle.contenu }}
          </p>
        </div>
      </div>
    </div>
  
    <section class="c-appels-offres" *ngIf="!showFilterPorts">
      <div class="container">
        <form class="form-ap" action="" method="get">
          <div class="form-row">
            <div class="col-md-3">
              <label for="region">{{ "mouvement.port" | translate }}</label>
              <select
                name="Ports"
                [(ngModel)]="selectedPort"
                class="form-control"
                (change)="portchange()"
              >
                <option value="">{{ "mouvement.selectport" | translate }}</option>
                <option
                  *ngFor="let port of ports"
                  [value]="
                    port.IdPort < 10 ? '0' + port.IdPort : '' + port.IdPort
                  "
                >
                  {{ port.CodePort | translate }}
                </option>
              </select>
            </div>
          </div>
          <!-- <div class="form-row">
            <div class="col-md-3">
              <label for="region">{{ "mouvement.Provenance" | translate }}</label>
              <select
                class="form-control"
                (change)="
                  selectedprovenance = $event.target.value; lancerFiltre()
                "
              >
                <option value="00">
                  {{ "mouvement.Selectionnertout" | translate }}
                </option>
                <option *ngFor="let prv of provenance" [value]="prv">
                  {{ prv }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="categorie">{{
                "mouvement.Consignataire" | translate
              }}</label>
              <select
                class="form-control"
                (change)="
                  selectedConsignataire = $event.target.value; lancerFiltre()
                "
              >
                <option value="00">
                  {{ "mouvement.Selectionnertout" | translate }}
                </option>
                <option *ngFor="let c of consignataire" [value]="c">
                  {{ c }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="">{{ "mouvement.TypeNavire" | translate }}</label>
              <select
                class="form-control"
                (change)="
                  selectedTypeNavire = $event.target.value; lancerFiltre()
                "
              >
                <option value="00">
                  {{ "mouvement.Selectionnertout" | translate }}
                </option>
                <option *ngFor="let t of typeNavire" [value]="t">{{ t }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="tag">{{ "mouvement.Situation" | translate }}</label>
              <select
                class="form-control"
                (change)="selectedSituation = $event.target.value; lancerFiltre()"
              >
                <option value="00">
                  {{ "mouvement.Selectionnertout" | translate }}
                </option>
                <option *ngFor="let s of situation" [value]="s">{{ s }}</option>
              </select>
            </div>
          </div> -->
        </form>
      </div>
    </section>

    <section class="results-appels-offres" *ngIf="selectedPort !== ''">
      <div class="container">
        <div class="row">
          <div class="col d-flex justify-content-between">
            <h2 class="size18">
              {{ "mouvement.RechercheResult" | translate }} :
            </h2>
            <p class="size18 text-uppercase mt-4 pt-1">
              {{
                selectedPort && mvmNaviresGlobals[selectedPort] !== undefined
                  ? (mvmNaviresGlobals[selectedPort] | mvmNvFilter: filters)
                      .length
                  : 0
              }}
              Résultat trouvés
            </p>
          </div>
        </div>
        <div
          class="row"
          [hidden]="
            selectedPort && mvmNaviresGlobals[selectedPort] !== undefined
              ? !(mvmNaviresGlobals[selectedPort] | mvmNvFilter: filters).length
              : true
          "
        >
          <div class="table-responsive">
            <table id="keywords" class="table">
              <thead class="thead-light">
                <tr>
                  <th class="text-center" scope="col">
                    {{ "mouvement.NomNavire" | translate }}
                  </th>
                  <th class="text-center" scope="col">
                    {{ "mouvement.TypeNavire" | translate }}
                  </th>
                  <th class="text-center" scope="col">
                   Mouvement <!-- à traduire {{ "mouvement.Situation" | translate }} -->
                  </th>
                  <th class="text-center" scope="col">
                    {{ "mouvement.Date" | translate }}
                  </th>
                  <th class="text-center" scope="col">
                    {{ "mouvement.Consignataire" | translate }}
                  </th>
                  <th class="text-center" scope="col">
                    {{ "mouvement.Operateur" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let nv of selectedPort && mvmNaviresGlobals[selectedPort]
                      ? (mvmNaviresGlobals[selectedPort] | mvmNvFilter: filters)
                      : []
                  "
                >
                  <td>{{ nv.nOM_NAVIREField }}</td>
                  <td>{{ nv.tYPE_NAVIREField }}</td>
                  <td>{{ nv.lIBELLE_MOUVEMENTField }}</td>
                  <td>{{ getDate(nv.dATE_MOUVEMENTField) }} {{getHeure(nv.dATE_MOUVEMENTField)}}</td>
                  <td>{{ nv.lIBELLE_CONSIGNATAIREField }}</td>
                  <td>{{ nv.lIBELLE_OPERATEURField }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </main>
  